import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
// import Sidebar from '../components/Sidebar';
// import DarkModeBtn from '../components/DarkModeBtn';
import LogoutButton from '../components/LogoutButton';
import { useUser } from '../contexts/UserContext';
import UserActionsBar from '../components/UserActionsBar';

const Settings = () => {
   // const { userName, userEmail } = useUser();
   const { userEmail } = useUser();
   // const [accountDetails, setAccountDetails] = useState({
   //    accountNumber: '123456789',
   //    memberSince: '01/07/2025',
   //    country: 'us'
   // });
   const [accountDetails] = useState({
      accountNumber: '123456789',
      memberSince: '01/07/2025',
      country: 'us'
   });
   // const [isPasswordHidden, setIsPasswordHidden] = useState(true);
   const [isPasswordHidden] = useState(true);
   // const [userPassword, setUserPassword] = useState('************');
   const [userPassword] = useState('************');

   useEffect(() => {
      // Aquí podrías hacer una llamada a la API para obtener los detalles del usuario
      // Ejemplo: fetchUserDetails();
   }, []);

   // const togglePasswordVisibility = () => {
   //    setIsPasswordHidden(!isPasswordHidden);
   // };

   const handleChangeProfilePicture = () => {
      // Implementar lógica para cambiar la imagen de perfil
      console.log('Changing profile picture');
   };

   const handleSaveChanges = () => {
      // Implementar lógica para guardar los cambios
      console.log('Saving changes');
   };

   // Función para obtener la bandera del país
   const getCountryFlag = (countryCode) => {
      return `https://hatscripts.github.io/circle-flags/flags/${countryCode.toLowerCase()}.svg`;
   };

   return (
      <div className="container-fluid max py-lg-5" page-key="Settings">
         {/* Cabecera común para ambas vistas */}
         <nav class="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            <div class="container-fluid px-0">
               <div className="row align-items-center w-100 mx-0" data-orders>
                  <div data-order="1" className="col col-lg-3 px-0">
                     <NavLink to="/dashboard" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                     </NavLink>
                  </div>
                  <div data-order="2" className="col-auto d-flex align-items-center gap-3 px-0">
                     <UserActionsBar />
                     <span className="d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <rect x="0.577148" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="9.73077" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="19.4615" width="27.4231" height="3.53846" fill="var(--white)" />
                        </svg>
                     </span>
                  </div>
                  <div data-order="3" className="collapse navbar-collapse" id="navbarNavDropdown">
                     <div className="col">
                        <nav className="ppt_navdash">
                           <NavLink to="/dashboard" className="link">Wallet</NavLink>
                           <NavLink to="/propt-tokens" className="link">Propt Tokens</NavLink>
                           {/* <span className="link">Earn</span> */}
                           <NavLink to="/support" className="link">SUPPORT</NavLink>
                           <NavLink to="/settings" className="link d-lg-none">SETTINGS</NavLink>
                           <span className="link d-lg-none">
                              <LogoutButton />
                           </span>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
         </nav>

         <div className="row mb-4">
            <div className="col-12">
               <h3 className="ppt_form_title mb-4 px-lg-3 w-100">Settings</h3>
            </div>

            {/* Account Details Section */}
            <div className="col-12 mb-4">
               <div className="settings-card">
                  <h3 className="settings-section-title">Account Details</h3>
                  <div className="settings-fields-container">
                     <div className="settings-field">
                        <span className="settings-field-label">Account Number:</span>
                        <span className="settings-field-value">{accountDetails.accountNumber}</span>
                     </div>

                     <div className="settings-field">
                        <span className="settings-field-label">Member since:</span>
                        <span className="settings-field-value">{accountDetails.memberSince}</span>
                     </div>

                     <div className="settings-field">
                        <span className="settings-field-label">Country</span>
                        <span className="settings-field-value">
                           <img
                              src={getCountryFlag(accountDetails.country)}
                              alt="Country flag"
                              className="country-flag"
                           />
                        </span>
                     </div>
                  </div>
               </div>
            </div>

            {/* Login Details Section */}
            <div className="col-12 mb-4">
               <div className="settings-card">
                  <h3 className="settings-section-title">Login Details</h3>
                  <div className="settings-fields-container">
                     <div className="settings-field">
                        <span className="settings-field-label">Email:</span>
                        <span className="settings-field-value">{userEmail || 'johndoe@gmail.com'}</span>
                     </div>

                     <div className="settings-field">
                        <span className="settings-field-label">Password:</span>
                        <span className="settings-field-value">
                           {isPasswordHidden ? '************' : userPassword}
                        </span>
                     </div>
                  </div>
               </div>
            </div>

            {/* Profile Picture Section */}
            <div className="col-12 mb-4">
               <div className="settings-card text-center text-lg-start">
                  <h3 className="settings-section-title">Profile picture</h3>
                  <div className="profile-picture-container flex-column flex-lg-row">
                     <div className="profile-picture">
                        {/* <img
                           // src={process.env.PUBLIC_URL + '/assets/img/default-avatar.svg'}
                           // src={process.env.PUBLIC_URL + '/assets/img/default-avatar.svg'}
                           alt="Profile"
                           className="user-avatar"
                        /> */}
                        <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <g clip-path="url(#clip0_29_537)">
                              <path d="M39.5 0.00195312C17.687 0.00195312 0 17.6855 0 39.5002C0 61.3149 17.6853 78.9985 39.5 78.9985C61.3164 78.9985 79 61.3149 79 39.5002C79 17.6855 61.3164 0.00195312 39.5 0.00195312ZM39.5 11.8124C46.7178 11.8124 52.5666 17.663 52.5666 24.8773C52.5666 32.0933 46.7178 37.9422 39.5 37.9422C32.2857 37.9422 26.4369 32.0933 26.4369 24.8773C26.4369 17.663 32.2857 11.8124 39.5 11.8124ZM39.4913 68.6715C32.2926 68.6715 25.6995 66.0499 20.614 61.7105C19.3752 60.6539 18.6604 59.1045 18.6604 57.4787C18.6604 50.1621 24.5821 44.3063 31.9005 44.3063H47.103C54.4231 44.3063 60.3223 50.1621 60.3223 57.4787C60.3223 59.1062 59.6109 60.6521 58.3703 61.7088C53.2867 66.0499 46.6918 68.6715 39.4913 68.6715Z" fill="white" fill-opacity="0.1" />
                           </g>
                           <defs>
                              <clipPath id="clip0_29_537">
                                 <rect width="79" height="79" fill="white" />
                              </clipPath>
                           </defs>
                        </svg>

                     </div>
                     <button
                        className="change-picture-btn"
                        onClick={handleChangeProfilePicture}
                     >
                        Change
                     </button>
                  </div>
               </div>
            </div>

            {/* Save Button */}
            <div className="col-12 mt-2 text-center text-lg-start">
               <button
                  className="ppt_btn_primary alt"
                  onClick={handleSaveChanges}
               >
                  Save changes
               </button>
            </div>
         </div>
      </div>
   );
};

export default Settings;